<template lang="pug">
a-modal(
  width="80%"
  :title="title"
  :visible="true"
  :footer="null"
  :closable="true"
  @cancel="hideModal"
  :bodyStyle="{height:'600px'}"
)
  div(class="d-flex flex-row-reverse justify-content-between mobile-view")
    div
      a-dropdown
        a-menu(slot="overlay")
          a-menu-item(
            key="1"
            @click="updateReloadInterval(0)"
          ) {{ $t('components.task_panel_modal.tpl.update_button_now') }}
          a-menu-item(
            key="2"
            @click="updateReloadInterval(10000)"
          ) {{ $t('components.task_panel_modal.tpl.update_button_10') }}
          a-menu-item(
            key="3"
            @click="updateReloadInterval(60000)"
          ) {{ $t('components.task_panel_modal.tpl.update_button_60') }}
        a-button
          span {{ $t('components.task_panel_modal.tpl.update_button_default') }}
          a-icon(type="down")
    div.d-flex
      div(v-for="buttonData, index in tabsData")
        button.mb-1.mr-1(
          type="button"
          :class="`btn btn-outline-${buttonData.class} btn-sm`"
          @click="toggleTaskTypeView(buttonData.view)"
        ) {{ $t(`components.task_panel_modal.tpl.${buttonData.label}`) }}
  .task-list
    a-list(
      v-if="tasks"
      size="small"
      bordered
      :data-source="showTasksByType ? tasksByType : tasks"
      :locale="{emptyText: $t('components.task_panel_modal.tpl.empty_list_placeholder')}"
    )
      a-list-item.w-100(slot="renderItem" slot-scope="item, index")
        .d-flex.w-100.list-item
          div(style="flex-grow:2")
            a-tag.font-weight-bold {{ `#${item.id.slice(0, 6)}` }}
          .justify-content-center.mobile-view-issuer(style="flex-grow:2; max-width:12%")
            div {{ item.issuer }}
          div(style="flex-grow:5")
            .d-flex.justify-content-center(class="desktop-view")
              .d-flex.flex-column(
                v-if="item.status === 'queued'"
                style="padding: 0px 155px 0px;"
              )
                a-tag(style="font-size:16px;") {{ $t('components.task_panel_modal.tpl.enqueued') }}
                span.text-black-50(style="font-size:14px;") {{ item.enqueuedAt }}
              a-steps.d-flex(v-else progress-dot :current="item.startedAt ? 2 : 0")
                a-step(
                  :description="item.enqueuedAt"
                )
                  div(slot="title")
                    span.mr-1 {{ $t('components.task_panel_modal.tpl.enqueued') }}
                a-step(
                  :title="$t('components.task_panel_modal.tpl.started')"
                  :description="item.startedAt"
                )
                a-step.ended(
                  v-if="item.status === 'finished'"
                  :description="item.endedAt"
                )
                  div(slot="title")
                    a-tag(
                      style="font-size:16px;background-color:#e3f7e6"
                    ) {{ $t('components.task_panel_modal.tpl.finished') }}
                a-step.failed(
                  v-if="['failed', 'stopped', 'canceled'].includes(item.status)"
                )
                  div(slot="title")
                    a-tag(
                      style="font-size:16px;background-color:#ffaaaa"
                    ) {{ $t(`components.task_panel_modal.tpl.${item.status}`) }}
                a-step.processing(
                  v-if="item.status === 'started' || \
                  !['finished', 'failed', 'stopped', 'canceled'].includes(item.status)"
                )
                  div(slot="title")
                    a-tag(
                      style="font-size:16px;background-color:#ffe189"
                    ) {{ $t('components.task_panel_modal.tpl.processing') }}
            div(class="mobile-view")
              .d-flex.flex-column(
                  v-if="item.status === 'queued'"
                )
                  a-tag.w-100(
                    style="font-size:16px;"
                  ) {{ $t('components.task_panel_modal.tpl.enqueued') }}
                  span.text-black-50(style="font-size:14px;") {{ item.enqueuedAt }}
              a-steps(v-else progress-dot :current="item.startedAt ? 2 : 0" direction="vertical")
                a-step(
                  :title="$t('components.task_panel_modal.tpl.enqueued')"
                  :description="item.enqueuedAt"
                )
                a-step(
                  :title="$t('components.task_panel_modal.tpl.started')"
                  :description="item.startedAt"
                )
                a-step.ended(
                  v-if="item.status === 'finished'"
                  :title="$t('components.task_panel_modal.tpl.finished')"
                  :description="item.endedAt"
                )
                a-step.failed(
                  v-if="['failed', 'stopped', 'canceled'].includes(item.status)"
                  :title="$t(`components.task_panel_modal.tpl.${item.status}`)"
                )
                a-step.processing(
                  v-if="item.status === 'started' || \
                  !['finished', 'failed', 'stopped', 'canceled'].includes(item.status)"
                  :title="$t('components.task_panel_modal.tpl.processing')"
                )
          div(
            :class="{hide: ['processing','queued'].includes(item.status)}"
            class="d-flex flex-column align-items-center mobile-view-column"
            style="flex-grow:2"
          )
            span(style="color: gray") {{ $t('components.task_panel_modal.tpl.elapsed_time') }}
            span.ml-1 {{ item.elapsedTime }}
          div(
            :class="{hide: ['processing', 'finished', 'queued'].includes(item.status)}"
            class="d-flex flex-column align-items-center mobile-view-column last-update-section"
            style="flex-grow:2"
          )
            span.text-black-50 {{ $t('components.task_panel_modal.tpl.last_update') }}
            span.ml-1 {{ item.lastHeartbeat }}
          div(v-if="item.status === 'finished'")
            .d-flex.justify-content-center(
              class="desktop-view"
            )
             a(
                :href="`/common-api/tasks/${item.id}/artifact`"
                class="btn btn-primary btn-sm"
              ) {{ $t('components.task_panel_modal.tpl.download_button') }}
            div(class="mobile-view")
              a.mt-1(
                :href="`/common-api/tasks/${item.id}/artifact`"
                class="btn btn-primary btn-sm"
              ) {{ $t('components.task_panel_modal.tpl.download_button') }}
          div(
            v-else
          )
            button(
              type="button"
              class="btn btn-primary btn-sm desktop-view"
              style="visibility:hidden"
            ) {{ $t('components.task_panel_modal.tpl.download_button') }}
  div(v-if="this.updateReloadIntervalText" class="update-text") {{ updateText }}
</template>

<script>

import { mapState } from 'vuex';
import { format, parseISO } from 'date-fns';
import { fetchTasks } from '@/api/common';

export default {
  data() {
    return {
      title: this.$t('components.task_panel_modal.js.title'),
      loading: false,
      tasks: [],
      tasksByType: [],
      showTasksByType: false,
      intervalId: null,
      updateReloadIntervalText: false,
      reloadInterval: null,
      tabsData: [
        { view: 'all', class: 'dark', label: 'all_button' },
        { view: 'started', class: 'warning', label: 'processing_button' },
        { view: 'finished', class: 'success', label: 'finished_button' },
        { view: 'failed', class: 'danger', label: 'failed_button' },
      ],
    };
  },
  computed: {
    ...mapState('login', [
      'user',
      'instance',
      'FORMATTED_TOKEN',
    ]),
    updateText() {
      return this.reloadInterval === 0
        ? this.$t('components.task_panel_modal.js.bottom_update_text_now')
        : this.$t('components.task_panel_modal.js.bottom_update_text_interval', { reloadInterval: this.reloadInterval });
    },
  },
  async mounted() {
    await this.fetchTasks();
  },
  methods: {
    calculateElapsedTime(startTime, finishTime, status, lastHeartbeat) {
      if (status === 'queued') return '00:00:00';

      const start = new Date(startTime || Date.now());
      const finish = new Date(finishTime || (status === 'failed' ? lastHeartbeat : Date.now()));

      if (start >= finish) return '00:00:00';

      let difference = finish - start;

      const hours = Math.floor(difference / (1000 * 60 * 60));
      difference %= 1000 * 60 * 60;

      const minutes = Math.floor(difference / (1000 * 60));
      difference %= 1000 * 60;

      const seconds = Math.floor(difference / 1000);

      return [hours, minutes, seconds].map(unit => String(unit).padStart(2, '0')).join(':');
    },
    formatTasks(tasks) {
      return tasks.sort((a, b) => new Date(b.enqueuedAt) - new Date(a.enqueuedAt))
        .map(item => ({
          ...item,
          enqueuedAt: format(parseISO(item.enqueuedAt), 'HH:mm d/MM/yyyy'),
          startedAt: item.startedAt
            ? format((parseISO(item.startedAt)), 'HH:mm d/MM/yyyy')
            : '',
          endedAt: item.endedAt ? format(parseISO(item.endedAt), 'HH:mm d/MM/yyyy') : '',
          lastHeartbeat: item.lastHeartbeat ? format(parseISO(item.lastHeartbeat), 'HH:mm d/MM/yyyy') : '',
          elapsedTime: this.calculateElapsedTime(
            item.startedAt,
            item.endedAt ? item.endedAt : '',
            item.status,
            item.lastHeartbeat,
          ),
        }));
    },
    toggleTaskTypeView(type) {
      switch (type) {
        case 'all':
          this.showTasksByType = false;
          break;
        case 'started':
        case 'finished':
        case 'failed':
          this.showTasksByType = true;
          this.tasksByType = this.tasks.filter(item => item.status === type);
          break;
        default:
          this.showTasksByType = false;
          break;
      }
    },
    async fetchTasks() {
      const rawTasks = await fetchTasks({
        userId: this.user.id, token: this.FORMATTED_TOKEN, instance: this.instance,
      });
      this.tasks = this.formatTasks(rawTasks);
    },
    async updateReloadInterval(reloadInterval) {
      this.reloadInterval = reloadInterval / 1000;
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      if (reloadInterval === 0) {
        await this.fetchTasks();
      } else {
        this.intervalId = setInterval(this.fetchTasks, reloadInterval);
      }
      this.updateReloadIntervalText = true;
    },
    async hideModal() {
      await this.$emit('hide');
    },
  },
};
</script>
<style>
.task-list {
  overflow: auto;
  max-height: 480px;
  margin-bottom: 5px;
}

.ant-list-item-content-single {
  display: flex;
  justify-content: center !important;
}

.processing>.ant-steps-item-icon>.ant-steps-icon .ant-steps-icon-dot {
  background-color: orange !important;
}

.ended>.ant-steps-item-icon>.ant-steps-icon .ant-steps-icon-dot {
  background-color: green !important;
}

.failed>.ant-steps-item-icon>.ant-steps-icon .ant-steps-icon-dot {
  background-color: red !important;
}

.desktop-view{
  display:block;
}
.mobile-view{
  display:none;
}
.update-text{
  font-weight: bold;
}

.hide {
  visibility: hidden;
}

@media (max-width: 575.98px) {
  .list-item {
    display: flex;
    flex-direction: column;
  }
  .status-section{
    display: flex;
    width: 500px;
  }
  .last-update-section{
    display: flex;
    width: 500px;
  }
  .status-badge {
    margin-right: 10px;
  }
  .last-update-label{
    margin-right: 10px;
  }
  .desktop-view{
    display:none !important;
  }
  .mobile-view{
    display:block !important;
  }
  .mobile-view-column {
    display:flex;
    flex-direction: row !important;
  }
  .mobile-view-issuer{
    max-width: 100% !important;
  }
}
</style>
